const PRODUCTION_ENDPOINTS_HOST = 'https://pixorion.ai'
const WATERMARK_ELEMENT_ID = 'environment-watermark'
const WATERMARK_ITEMS_COUNT = 48

const normalizeEndpointHost = (host: string | undefined) => host?.trim().replace(/\/+$/, '') ?? ''

export const shouldShowEnvironmentWatermark = () => {
    return normalizeEndpointHost(__ENDPOINTS_HOST__) !== PRODUCTION_ENDPOINTS_HOST
}

export const applyEnvironmentWatermark = () => {
    const endpointHost = normalizeEndpointHost(__ENDPOINTS_HOST__)
    const existingWatermark = document.getElementById(WATERMARK_ELEMENT_ID)

    if (!endpointHost || endpointHost === PRODUCTION_ENDPOINTS_HOST) {
        existingWatermark?.remove()
        return
    }

    if (existingWatermark) {
        return
    }

    const watermarkElement = document.createElement('div')
    watermarkElement.id = WATERMARK_ELEMENT_ID
    watermarkElement.className = 'environment-watermark'
    watermarkElement.setAttribute('aria-hidden', 'true')

    Array.from({ length: WATERMARK_ITEMS_COUNT }).forEach(() => {
        const itemElement = document.createElement('span')
        itemElement.textContent = endpointHost
        watermarkElement.appendChild(itemElement)
    })

    document.body.appendChild(watermarkElement)
}
